import { Box, Stack, styled, Typography } from '@mui/material';
import { PrimaryPaper, type PrimaryPaperProps } from '../../atoms/layout';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../atoms/buttons';
import RefreshIcon from '@mui/icons-material/Refresh';

export type NewVersionBadgeProps = PrimaryPaperProps & {
  localizationSubset: string;
  onRefresh?: () => void;
};

export const NewVersionBadge = ({ localizationSubset, onRefresh, ...props }: NewVersionBadgeProps) => {
  const handleRefresh = () => {
    onRefresh && onRefresh();
  };
  return (
    <StyledPrimaryPaper {...props}>
      <Stack direction={'row'} sx={{ px: 2 }}>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <Typography variant="subtitle1">
            <FormattedMessage id={`${localizationSubset}.message.title`} />
          </Typography>
        </Stack>
        <Box flex={1} />
        <Button variant="contained" endIcon={<RefreshIcon />} onClick={handleRefresh} size="small">
          <FormattedMessage id={`${localizationSubset}.refreshButton.label`} />
        </Button>
      </Stack>
    </StyledPrimaryPaper>
  );
};

const StyledPrimaryPaper = styled(PrimaryPaper)(({ theme }) => ({
  borderRadius: 0,
  padding: theme.spacing(1),
  marginBottom: theme.spacing(2),
  marginTop: 0,
}));
